import { render, staticRenderFns } from "./open-action-documents.vue?vue&type=template&id=d2fd2e54&scoped=true"
import script from "./open-action-documents.vue?vue&type=script&lang=js"
export * from "./open-action-documents.vue?vue&type=script&lang=js"
import style0 from "./open-action-documents.vue?vue&type=style&index=0&id=d2fd2e54&prod&lang=scss"
import style1 from "./open-action-documents.vue?vue&type=style&index=1&id=d2fd2e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fd2e54",
  null
  
)

export default component.exports